import React from "react";

export default function Error({ message }) {
  return (
    <div className="text-red-500 text-center">{message !== "" && message}</div>
  );
}
